import React from 'react';
import { Clock, Facebook, Instagram } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { SITE_CONFIG } from '../config/siteConfig';

const TopBar = () => {
    const [currentHourIndex, setCurrentHourIndex] = React.useState(0);
    const hours = React.useMemo(() => SITE_CONFIG.contact.hours.split('|').map(h => h.trim()), []);

    React.useEffect(() => {
        if (hours.length <= 1) return;
        const interval = setInterval(() => {
            setCurrentHourIndex((prev) => (prev + 1) % hours.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [hours.length]);

    return (
        <div className="bg-zinc-900 border-b border-zinc-800 py-2 hidden md:block relative z-50">
            <div className="max-w-[1800px] mx-auto px-6 md:px-12">
                <div className="flex justify-between items-center text-[10px] font-bold tracking-widest uppercase text-zinc-500">
                    <div className="flex items-center gap-6">
                        <div className="flex items-center gap-4 h-4">
                            <a
                                href={SITE_CONFIG.socialMedia.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white hover:text-zinc-400 transition-colors"
                                title="Instagram"
                            >
                                <Instagram size={14} />
                            </a>
                            <a
                                href={SITE_CONFIG.socialMedia.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white hover:text-zinc-400 transition-colors"
                                title="Facebook"
                            >
                                <Facebook size={14} />
                            </a>
                            <a
                                href={SITE_CONFIG.socialMedia.tiktok}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white hover:text-zinc-400 transition-colors"
                                title="TikTok"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                >
                                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    <div className="flex items-center">
                        <div className="overflow-hidden h-4 flex items-center">
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={currentHourIndex}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.3 }}
                                    className="flex items-center gap-2 whitespace-nowrap text-white"
                                >
                                    <Clock size={12} className="flex-shrink-0" />
                                    <span>{hours[currentHourIndex]}</span>
                                </motion.div>
                            </AnimatePresence>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopBar;
